import ApiService from '../../utils/fetch';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const inventoryUrl = `${BASE_URL}inventory/`;
const totalstockUrl = `${BASE_URL}inventory/inventoryTotalStock/`;
const onHandUrl     = `${BASE_URL}/inventory/inventoryOnHand/`;

export const fetchInventory = async ({
  page = 0,
  size = 10,
  sort = [],
  filters = {},
}) => {


  const params = new URLSearchParams();
  params.append('page', page);
  params.append('size', size);
  if (sort && Array.isArray(sort)) {
    sort.forEach(s => params.append('sort', s)); // multiple sort params
  }

  const response = await ApiService.post(
    `${inventoryUrl}?${params}`,
    {
      ...filters, 
    }
  );

  const res = response.data;

  return res;
};

export const fetchInventoryTotalStock = async (itemNo, siteCode) => {
    const url = `${totalstockUrl}${itemNo}/${siteCode}`;
    const response = await ApiService.get(url);
    console.log('Total Stock Response:', response);
    return response.data.stockItems || [];
};

export const fetchOnhand = async (itemNo, siteCode) => {
    const url = `${onHandUrl}${itemNo}/${siteCode}`;
    const response = await ApiService.get(url);
     return response.data.onHandItems || [];
};

/**
 * Fetch distinct filter options for a specific column
 * @param {string} column - Column name
 * @param {object} appliedFilters - Currently applied filters for cascading behavior
 * @returns {Promise<string[]>} Array of distinct values for the column
 */
export const fetchFilterOptions = async (column, appliedFilters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('column', column);

    const requestBody = {
      appliedFilters: appliedFilters?.appliedFilters || appliedFilters || {},
    };
    if (appliedFilters?.selectedStates) {
      requestBody.selectedStates = appliedFilters.selectedStates;
    }
    if (appliedFilters?.selectedExceptions) {
      requestBody.selectedExceptions = appliedFilters.selectedExceptions;
    }

    const response = await ApiService.post(
      `${inventoryUrl}filter-options?${params}`,
      requestBody
    );
    return response.data.values || [];
  } catch (error) {
    console.error(`Error fetching filter options for ${column}:`, error);
    return [];
  }
};